exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services-types-list-page .content-client-list{position:relative}.services-types-list-page .btn-new-client{position:absolute;right:60px;top:12px}.services-types-list-page .content-list-table{margin-top:60px}", ""]);

// exports
